<template>
  <div class="card shadow table-container vld-parent" ref="rooms_table">
    <div class="card-header bg-transparent">
      <h3 class="mb-0">
        <i class="fas fa-building mr-1"></i> Espaços da empresa
        <base-button
          size="sm"
          type="primary"
          class="float-right"
          :custom="true"
          @click="handleNewEspaco()"
          ><i class="fas fa-plus mr-1"></i> Adicionar novo
        </base-button>
      </h3>
    </div>

    <div class="table-responsive">
      <base-table
        thead-classes="thead-light"
        class="table align-items-center table-flush"
        tbody-classes="list"
        :data="tableData"
        type="hover"
      >
        <template slot="columns">
          <th>Espaço</th>
          <th>Status</th>
          <th>Tipo</th>
          <th>Custo</th>
          <th>Agenda</th>
          <th>Ações</th>
        </template>

        <template slot-scope="{ row }">
          <th scope="row">{{ row.name }}</th>
          <td>{{ roomStatus[row.status] }}</td>
          <td>{{ row.type }}</td>
          <td>{{ row.price ? formatValue(row.price) : "Gratuito" }}</td>
          <td>
            <base-button
              v-if="row.link"
              @click="handleOpenModalSchedule(row)"
              type="link"
              class="p-0 m-0"
              title="Visualizar agenda"
            >
              Abrir</base-button
            >
            <span v-else title="Nenhuma agenda cadastrada para a sala"
              >N/A</span
            >
          </td>
          <td>
            <base-button
              @click="handleViewRoom(row.id)"
              type="white"
              icon="fas fa-edit"
              class="text-info mt--1"
              :iconOnly="true"
              title="Gerenciar espaço"
            ></base-button>
            <base-button
              @click="handleViewReservations(row.id)"
              type="white"
              icon="fas fa-list"
              class="text-primary mt--1"
              :iconOnly="true"
              title="Ver reservas do espaço"
            ></base-button>
          </td>
        </template>
      </base-table>
      <p v-if="empty" class="text-center text-warning mt-3">
        Não há nenhum espaço cadastrado no momento
      </p>
    </div>
    <modal
      :show.sync="modalSchedule.show"
      modal-classes="modal-dialog-centered modal-lg"
      body-classes="pb-0"
    >
      <h6 slot="header" class="modal-title" id="modal-title-notification">
        Visualizar agenda
      </h6>
      <div class="pb-3 text-center">
        <h4 class="heading">
          Agenda
          {{ modalSchedule.room.name }}
        </h4>
      </div>
      <div class="row" v-if="modalSchedule.room">
        <iframe
          :src="modalSchedule.room.link"
          style="border: 0"
          width="100%"
          height="500"
          frameborder="0"
          scrolling="no"
        ></iframe>
      </div>
      <template slot="footer">
        <base-button
          type="link"
          text-color="dark"
          class="ml-auto"
          @click="modalSchedule.show = false"
        >
          Voltar
        </base-button>
      </template>
    </modal>
  </div>
</template>
<script>
import api from "@/services/api";

export default {
  name: "espacos-table",
  data() {
    return {
      tableData: [],
      empty: false,
      modalSchedule: {
        show: false,
        room: ""
      },
      roomStatus: {
        visible: "Visível",
        hidden: "Oculto"
      }
    };
  },
  async mounted() {
    let loader = this.$loading.show({
      container: this.$refs.rooms_table,
      width: 90,
      height: 90
    });
    try {
      const { data } = await api.get("/company/rooms");
      if (data.length) {
        this.tableData = data;
        this.$emit("stats", { numRooms: data.length });
      } else this.empty = true;
      loader.hide();
    } catch (e) {
      this.$toasted.error("Ocorreu um erro ao recuperar as informações");
    }
  },
  methods: {
    handleNewEspaco() {
      this.$router.push("/empresa/espacos/novo");
    },
    handleOpenModalSchedule(room) {
      this.modalSchedule.room = room;
      this.modalSchedule.show = true;
    },
    handleViewRoom(roomId) {
      this.$router.push(`/empresa/espacos/${roomId}/editar`);
    },
    handleViewReservations(roomId) {
      this.$router.push(`/empresa/espacos/reservas/relatorio?espaco=${roomId}`);
    }
  }
};
</script>
<style scoped>
.text-seagreen {
  color: seagreen;
}
</style>
